
import makeStyles from '@material-ui/styles/makeStyles';

const style = makeStyles(() => ({
    centerLoader:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
    }
}));

export default style;